<template>

</template>

<script>
  import {getLodop} from '../assets/js/LodopFuncs';
  import ElButton from "../../node_modules/element-ui/packages/button/src/button";
  export default {
    props:['deal_id','rkd_id','ckd_id','dhd_id','cgd_id','printData','dealId','rkdId','ckdId','dhdId','cgdId','printLoading','printLoadings'],
    components: {ElButton},
    data() {
      return {

      }
    },
    created() {

    },
    methods: {
      //打印
      printBill(){
        let _this=this;
        //订单
        if(_this.deal_id){
          _this.axios.post(_this.$store.state.urlHttp+'/xxtask/webprint/'+_this.deal_id+'/deal?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
            _this.$emit('printLoadings',false);
//            console.log(res.data);
            if(res.data.code==201){
              let LODOP= getLodop();
              LODOP.PRINT_INIT('订单'); //打印初始化
              if(res.data.prt_type==1){
                LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
              }else if(res.data.prt_type==2){
                LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                LODOP.SET_PRINT_PAGESIZE(3,res.data.print_w+'cm',85,''); //设定纸张大小
              }else if(res.data.prt_type==4){
                LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',res.data.html); //增加表格打印项
                LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
              }
//              LODOP.PRINT_DESIGN(); //打印设计
//              LODOP.PRINT_SETUP(); //打印维护
             LODOP.PREVIEW(); //打印预览
              // LODOP.PRINT(); //直接打印
            }else {
              _this.openWar(res.data.msg)
            }
          }).catch(function (error) {
            _this.openErr(_this.$t("message.requestFailure"));
            _this.$emit('printLoadings',false);
          });
        }
        //入库单
        if(_this.rkd_id){
          _this.axios.post(_this.$store.state.urlHttp+'/xxtask/webprint/'+_this.rkd_id+'/rkd?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
            _this.$emit('printLoadings',false);
//            console.log(res.data);
            if(res.data.code==201){
              let LODOP= getLodop();
              LODOP.PRINT_INIT('入库单'); //打印初始化
              if(res.data.prt_type==1){
                LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
              }else if(res.data.prt_type==2){
                LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                LODOP.SET_PRINT_PAGESIZE(3,res.data.print_w+'cm',85,''); //设定纸张大小
              }else if(res.data.prt_type==4){
                LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',res.data.html); //增加表格打印项
                LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
              }
//              LODOP.PRINT_DESIGN(); //打印设计
//              LODOP.PRINT_SETUP(); //打印维护
//              LODOP.PREVIEW(); //打印预览
              LODOP.PRINT(); //直接打印
            }else {
              _this.openWar(res.data.msg)
            }
          }).catch(function (error) {
            _this.openErr(_this.$t("message.requestFailure"));
            _this.$emit('printLoadings',false);
          });
        }
        //出库单
        if(_this.ckd_id){
          _this.axios.post(_this.$store.state.urlHttp+'/xxtask/webprint/'+_this.ckd_id+'/ckd?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
            _this.$emit('printLoadings',false);
//            console.log(res.data);
            if(res.data.code==201){
              let LODOP= getLodop();
              LODOP.PRINT_INIT('出库单'); //打印初始化
              if(res.data.prt_type==1){
                LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
              }else if(res.data.prt_type==2){
                LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                LODOP.SET_PRINT_PAGESIZE(3,res.data.print_w+'cm',85,''); //设定纸张大小
              }else if(res.data.prt_type==4){
                LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',res.data.html); //增加表格打印项
                LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
              }
//              LODOP.PRINT_DESIGN(); //打印设计
//              LODOP.PRINT_SETUP(); //打印维护
//              LODOP.PREVIEW(); //打印预览
              LODOP.PRINT(); //直接打印
            }else {
              _this.openWar(res.data.msg)
            }
          }).catch(function (error) {
            _this.openErr(_this.$t("message.requestFailure"));
            _this.$emit('printLoadings',false);
          });
        }
        //调拨单
        if(_this.dhd_id){
          _this.axios.post(_this.$store.state.urlHttp+'/xxtask/webprint/'+_this.dhd_id+'/dbd?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
            _this.$emit('printLoadings',false);
//            console.log(res.data);
            if(res.data.code==201){
              let LODOP= getLodop();
              LODOP.PRINT_INIT('调拨单'); //打印初始化
              if(res.data.prt_type==1){
                LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
              }else if(res.data.prt_type==2){
                LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                LODOP.SET_PRINT_PAGESIZE(3,res.data.print_w+'cm',85,''); //设定纸张大小
              }else if(res.data.prt_type==4){
                LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',res.data.html); //增加表格打印项
                LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
              }
//              LODOP.PRINT_DESIGN(); //打印设计
//              LODOP.PRINT_SETUP(); //打印维护
//              LODOP.PREVIEW(); //打印预览
              LODOP.PRINT(); //直接打印
            }else {
              _this.openWar(res.data.msg)
            }
          }).catch(function (error) {
            _this.openErr(_this.$t("message.requestFailure"));
            _this.$emit('printLoadings',false);
          });
        }
        //采购单
        if(_this.cgd_id){
          _this.axios.post(_this.$store.state.urlHttp+'/xxtask/webprint/'+_this.cgd_id+'/cgd?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
            _this.$emit('printLoadings',false);
//            console.log(res.data);
            if(res.data.code==201){
              let LODOP= getLodop();
              LODOP.PRINT_INIT('采购单'); //打印初始化
              if(res.data.prt_type==1){
                LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
              }else if(res.data.prt_type==2){
                LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                LODOP.SET_PRINT_PAGESIZE(3,res.data.print_w+'cm',85,''); //设定纸张大小
              }else if(res.data.prt_type==4){
                LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',res.data.html); //增加表格打印项
                LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
              }
//              LODOP.PRINT_DESIGN(); //打印设计
//              LODOP.PRINT_SETUP(); //打印维护
//              LODOP.PREVIEW(); //打印预览
              LODOP.PRINT(); //直接打印
            }else {
              _this.openWar(res.data.msg)
            }
          }).catch(function (error) {
            _this.openErr(_this.$t("message.requestFailure"));
            _this.$emit('printLoadings',false);
          });
        }
        //打印条码
        if(_this.printData){
          let goodsData=_this.printData;
          let LODOP= getLodop();
          LODOP.PRINT_INIT('条码'); //打印初始化
          LODOP.ADD_PRINT_TEXT(0,0,"4cm","3cm",goodsData.goods_name);
          LODOP.ADD_PRINT_TEXT(15,0,"4cm","3cm",_this.$t("message.spec")+":"+goodsData.sku_vname);
          if(goodsData.dim_ratio == 1&&goodsData.unit_name == goodsData.sub_uname){
            LODOP.ADD_PRINT_TEXT(30,0,"4cm","3cm",_this.$t("message.company")+":"+goodsData.unit_name);
          }else{
            LODOP.ADD_PRINT_TEXT(30,0,"4cm","3cm",_this.$t("message.company")+":"+goodsData.unit_name+"/"+goodsData.sub_uname);
          }
          LODOP.ADD_PRINT_TEXT(45,0,"4cm","3cm",_this.$t("message.itemNumber")+":"+goodsData.gcode);
          if(goodsData.dim_ratio == 1&&goodsData.unit_name == goodsData.sub_uname){
            LODOP.ADD_PRINT_TEXT(60,0,"4cm","3cm",_this.$t("message.unitPrice")+":"+goodsData.a_p);
          }else{
            LODOP.ADD_PRINT_TEXT(60,0,"4cm","3cm",_this.$t("message.unitPrice")+":"+goodsData.a_p+"/"+goodsData.a_p_l);
          }
          LODOP.ADD_PRINT_BARCODE(75,0,"4cm",35,"128B",goodsData.barcode);
          // LODOP.PRINT_DESIGN(); //打印设计
          // LODOP.PRINT_SETUP(); //打印维护
          // LODOP.PREVIEW(); //打印预览
          LODOP.PRINT(); //直接打印
        }
      },
      //批量打印
      batchPrint(){
        let _this=this;
        //订单
        if(_this.dealId){
          for(let i of _this.dealId){
            _this.axios.post(_this.$store.state.urlHttp+'/xxtask/webprint/'+i+'/deal?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
//              console.log(res.data);
              if(res.data.code==201){
                let LODOP= getLodop();
                LODOP.PRINT_INIT('订单'); //打印初始化
                if(res.data.prt_type==1){
                  LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                  LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
                }else if(res.data.prt_type==2){
                  LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                  LODOP.SET_PRINT_PAGESIZE(3,res.data.print_w+'cm',85,''); //设定纸张大小
                }else if(res.data.prt_type==4){
                  LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',res.data.html); //增加表格打印项
                  LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                  LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
                }
//                LODOP.PRINT_DESIGN(); //打印设计
//                LODOP.PRINT_SETUP(); //打印维护
//                LODOP.PREVIEW(); //打印预览
                LODOP.PRINT(); //直接打印
              }else {
                _this.openWar(res.data.msg)
              }
            }).catch(function (error) {
              _this.openErr(_this.$t("message.requestFailure"));
            });
          }
        }
        //入库单
        if(_this.rkdId){
          for(let i of _this.rkdId){
            _this.axios.post(_this.$store.state.urlHttp+'/xxtask/webprint/'+i+'/rkd?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
//              console.log(res.data);
              if(res.data.code==201){
                let LODOP= getLodop();
                LODOP.PRINT_INIT('入库单'); //打印初始化
                if(res.data.prt_type==1){
                  LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                  LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
                }else if(res.data.prt_type==2){
                  LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                  LODOP.SET_PRINT_PAGESIZE(3,res.data.print_w+'cm',85,''); //设定纸张大小
                }else if(res.data.prt_type==4){
                  LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',res.data.html); //增加表格打印项
                  LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                  LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
                }
//                LODOP.PRINT_DESIGN(); //打印设计
//                LODOP.PRINT_SETUP(); //打印维护
//                LODOP.PREVIEW(); //打印预览
                LODOP.PRINT(); //直接打印
              }else {
                _this.openWar(res.data.msg)
              }
            }).catch(function (error) {
              _this.openErr(_this.$t("message.requestFailure"));
            });
          }
        }
        //出库单
        if(_this.ckdId){
          for(let i of _this.ckdId){
            _this.axios.post(_this.$store.state.urlHttp+'/xxtask/webprint/'+i+'/ckd?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
//              console.log(res.data);
              if(res.data.code==201){
                let LODOP= getLodop();
                LODOP.PRINT_INIT('出库单'); //打印初始化
                if(res.data.prt_type==1){
                  LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                  LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
                }else if(res.data.prt_type==2){
                  LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                  LODOP.SET_PRINT_PAGESIZE(3,res.data.print_w+'cm',85,''); //设定纸张大小
                }else if(res.data.prt_type==4){
                  LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',res.data.html); //增加表格打印项
                  LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                  LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
                }
  //              LODOP.PRINT_DESIGN(); //打印设计
  //              LODOP.PRINT_SETUP(); //打印维护
  //              LODOP.PREVIEW(); //打印预览
                LODOP.PRINT(); //直接打印
              }else {
                _this.openWar(res.data.msg)
              }
            }).catch(function (error) {
              _this.openErr(_this.$t("message.requestFailure"));
            });
          }
        }
        //调拨单
        if(_this.dhdId){
          for(let i of _this.dhdId){
            _this.axios.post(_this.$store.state.urlHttp+'/xxtask/webprint/'+i+'/dbd?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
//              console.log(res.data);
              if(res.data.code==201){
                let LODOP= getLodop();
                LODOP.PRINT_INIT('调拨单'); //打印初始化
                if(res.data.prt_type==1){
                  LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                  LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
                }else if(res.data.prt_type==2){
                  LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                  LODOP.SET_PRINT_PAGESIZE(3,res.data.print_w+'cm',85,''); //设定纸张大小
                }else if(res.data.prt_type==4){
                  LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',res.data.html); //增加表格打印项
                  LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                  LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
                }
  //              LODOP.PRINT_DESIGN(); //打印设计
  //              LODOP.PRINT_SETUP(); //打印维护
  //              LODOP.PREVIEW(); //打印预览
                LODOP.PRINT(); //直接打印
              }else {
                _this.openWar(res.data.msg)
              }
            }).catch(function (error) {
              _this.openErr(_this.$t("message.requestFailure"));
            });
          }
        }
        //采购单
        if(_this.cgdId){
          for(let i of _this.cgdId){
            _this.axios.post(_this.$store.state.urlHttp+'/xxtask/webprint/'+i+'/cgd?sessionid='+_this.$store.state.Login.sessionid).then(function(res){
//              console.log(res.data);
              if(res.data.code==201){
                let LODOP= getLodop();
                LODOP.PRINT_INIT('采购单'); //打印初始化
                if(res.data.prt_type==1){
                  LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                  LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
                }else if(res.data.prt_type==2){
                  LODOP.ADD_PRINT_HTM(0,0,'100%','100%',res.data.html); //增加超文本项
                  LODOP.SET_PRINT_PAGESIZE(3,res.data.print_w+'cm',85,''); //设定纸张大小
                }else if(res.data.prt_type==4){
                  LODOP.ADD_PRINT_TABLE(0,0,'100%','100%',res.data.html); //增加表格打印项
                  LODOP.SET_PRINT_STYLEA(0,"TableHeightScope",1);
                  LODOP.SET_PRINT_PAGESIZE(0,res.data.print_w+'cm',res.data.print_h+'cm',''); //设定纸张大小
                }
  //              LODOP.PRINT_DESIGN(); //打印设计
  //              LODOP.PRINT_SETUP(); //打印维护
  //              LODOP.PREVIEW(); //打印预览
                LODOP.PRINT(); //直接打印
              }else {
                _this.openWar(res.data.msg)
              }
            }).catch(function (error) {
              _this.openErr(_this.$t("message.requestFailure"));
            });
          }
        }
      },
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/getLodop.vue